import type { ChangeEvent, MouseEvent } from "react";
import Box from "@mui/material/Box";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import { toEdgeShadow } from "@/app/shadow.utils";

interface ListGridFooterProps {
  /** e.g. "1,514 rows" / "307 orders match the filters". */
  summary: string;
  /** Rows the filter matches. */
  total: number;
  /** Zero-based. */
  page: number;
  pageSize: number;
  pageSizes: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
}

/** A ListGrid's footer: a summary on the left and the pager on the right. The list owns the page state. */
export const ListGridFooter = (props: ListGridFooterProps) => {
  const { summary, total, page, pageSize, pageSizes, onPageChange, onPageSizeChange } = props;

  const handlePageChange = (_event: MouseEvent<HTMLButtonElement> | null, nextPage: number) => {
    onPageChange(nextPage);
  };

  const handlePageSizeChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onPageSizeChange(Number(event.target.value));
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        bgcolor: "background.default",
        boxShadow: (theme) => toEdgeShadow(theme, "top"),
        display: "flex",
        flexShrink: 0,
        justifyContent: "space-between",
        pl: 2,
        position: "relative",
        zIndex: 1,
      }}
    >
      <Typography
        color="text.secondary"
        variant="body2"
      >
        {summary}
      </Typography>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handlePageSizeChange}
        page={page}
        rowsPerPage={pageSize}
        rowsPerPageOptions={pageSizes}
        sx={{ borderColor: "divider" }}
      />
    </Box>
  );
};
